import React from 'react';
import { formatStringIfEducationSavings } from 'services/BeneficiaryV2';
export const DeleteBeneConfirmation = ({ isEsa }) => {
  return (
      <div className="b-padding--organism-jumbo">
        <div className="b-typography-serif--headline--200 b-font-weight-bold b-margin--micro--normal">
          {formatStringIfEducationSavings("Are you sure you want to submit without adding beneficiaries?", isEsa)}
        </div>
        <div className="b-typography-sans-serif--body--200 b-font-weight-light b-margin--micro--normal">
          {formatStringIfEducationSavings("You have not named any beneficiaries for your account.", isEsa)}
        </div>
      </div>
  );
};

